module.exports = __webpack_public_path__ + "main/assets/public/player-controls/start-icon.4623fa156080fe2a.svg";